import type { PublicState } from '@karozik/shared';

export function momentText(state: PublicState): { emoji: string; text: string } | null {
  const m = state.moment;
  if (state.mic.active) return { emoji: '🎤', text: state.mic.speaker ? `On écoute ${state.mic.speaker}` : 'Un peu de silence, quelqu’un prend la parole' };
  if (!m) return null;
  switch (m.type) {
    case 'birthday':
      return { emoji: '🎂', text: `Joyeux anniversaire ${m.name} !` };
    case 'slows':
      return { emoji: '💞', text: 'C’est l’heure des slows : invitez quelqu’un !' };
    case 'collective':
      return { emoji: '🕺', text: m.label ? `Tous sur la piste : ${m.label} !` : 'Danse collective : tout le monde sur la piste !' };
    case 'photo':
      return { emoji: '📸', text: 'Photo de groupe ! Tout le monde devant l’écran' };
    case 'lastdance':
      return { emoji: '🌙', text: 'Dernière danse…' };
    case 'announce':
      return { emoji: '📣', text: m.text };
  }
}

export function MomentBanner({ state }: { state: PublicState }) {
  const m = momentText(state);
  if (!m) return null;
  return (
    <div className="bg-gradient-neon animate-pop mt-4 flex items-center gap-3 rounded-2xl px-4 py-3 font-semibold">
      <span className="text-2xl">{m.emoji}</span>
      <span>{m.text}</span>
    </div>
  );
}
